 <template lang="pug">
  section#files
    v-container.px-10(fluid)
      v-row(justify-center, style="overflow: hidden")
        v-col
          h2.primary--text {{$t('Schema.Summary')}}
      v-row
        v-col
          h3.primary--text.pb-5  {{$t('Order.externalId')}} {{ parentInstance.externalId}}
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text {{$t('Order.generalInfo')}}
        v-col.summary-col(cols="10")
          v-row()
            v-col.justify-center(cols="3")
              span(class="summary-header") {{$t('Order.shipperReference')}}:
              span(class="summary-text") {{ parentInstance.shipperReference }}
            v-col.justify-center(cols="3")
              span(class="summary-header") {{$t('Order.receiverReference')}}:
              span(class="summary-text") {{ parentInstance.receiverReference }}
            v-col.justify-center(cols="3")
              span(class="summary-header") {{$t('Order.user')}}:
              span(class="summary-text") {{ summaryInstance.createdBy }}
            v-col.justify-center(cols="3")
              span(class="summary-header") {{$t('Order.businessScope')}}:
              span(class="summary-text") {{ summaryInstance.businessScope }}
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text {{$t('Order.pickAndDelivery')}}
        v-col.summary-col.justify-center.pt-3(cols="5")
          span(class="summary-header") {{$t('Common.requestedDate', {type: 'Pickup'})}}:
          br
          span(v-if="summaryInstance.requestedPickUpFromDate != null" class="summary-text") {{ $formattedDate(summaryInstance.requestedPickUpFromDate, true) }}
          span(v-if="summaryInstance.requestedPickUpToDate != null" class="summary-text")   -- {{ $formattedDate(summaryInstance.requestedPickUpToDate, true) }}
          br
          span(class="summary-header") {{$t('Order.shipFrom')}}:
          span(class="summary-text") {{ summaryInstance.partyFromName }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromStreetName }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromInteriorNumber }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromCityName }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromPostalCode }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromRemarks }}
          br
          v-row(v-for="extData in summaryInstance.partyFromExtraData")
            span.pl-3(class="summary-text") {{ `${extData.extraField.label}: ${extData.value}` }}
            br
          span(class="summary-header") {{$tc('Contact._name', 2)}}:
          br
          v-row(v-for="c in summaryInstance.partyFromContacts")
            span.pl-3(class="summary-text") {{ c.contact }}
            br
        v-col.summary-col.justify-center.pt-3(cols="5")
          span(class="summary-header") {{$t('Common.requestedDate', {type: 'Delivery'})}}:
          br
          span(v-if="summaryInstance.requestedDeliveryFromDate != null" class="summary-text") {{ $formattedDate(summaryInstance.requestedDeliveryFromDate, true) }}
          span(v-if="summaryInstance.requestedDeliveryToDate != null" class="summary-text")   -- {{ $formattedDate(summaryInstance.requestedDeliveryToDate, true) }}
          br
          span(class="summary-header") {{$t('Order.shipTo')}}:
          span(class="summary-text") {{ summaryInstance.partyToName }}
          br
          span(class="summary-text") {{ summaryInstance.partyToStreetName }}
          br
          span(class="summary-text") {{ summaryInstance.partyToInteriorNumber }}
          br
          span(class="summary-text") {{ summaryInstance.partyToCityName }}
          br
          span(class="summary-text") {{ summaryInstance.partyToPostalCode }}
          br
          span(class="summary-text") {{ summaryInstance.partyToRemarks }}
          br
          v-row(v-for="extData in summaryInstance.partyToExtraData")
            span.pl-3(class="summary-text") {{ `${extData.extraField.label}: ${extData.value}` }}
            br
          span(class="summary-header") {{$tc('Contact._name', 2)}}:
          br
          v-row(v-for="c in summaryInstance.partyToContacts")
            span.pl-3(class="summary-text") {{ c.contact }}
            br
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text {{$tc('OrderLine._name', 2)}}
        v-col.summary-col(cols="10")
          template(v-for="(ol, index) in summaryInstance.orderLines")
            v-row
              v-col.justify-center.pb-0.pr-0(cols="3")
                span(class="summary-header") {{ $t('OrderLine.lineNumber') }}:
                span(class="summary-text") {{ ol.lineNumber != null ? ol.lineNumber : (index + 1) }}
              v-col.justify-center.py-0.pr-0(cols="3")
                span(class="summary-header") {{ $t('OrderLine.urgencyLevel') }}:
                span(class="summary-text") {{ ol.urgencyLevel }}
              v-col.justify-center.py-0.pr-0(cols="3")
                span(class="summary-header") {{ $t('OrderLine.status') }}:
                span(class="summary-text") {{ ol.status != null ? ol.status.name : "" }}
            v-row
              v-col.justify-center.py-0.pr-0(cols="3")
                span(class="summary-header") {{ $t('OrderLine.requestedQuantity') }}:
                span(class="summary-text") {{ ol.requestedQuantity }}
              v-col.justify-center.py-0.pr-0(cols="2")
                span(class="summary-header") {{ $t('OrderLine.availableQuantity') }}:
                span(class="summary-text") {{ ol.availableQuantity }}
              v-col.justify-center.py-0.pr-0(cols="1")
                span(class="summary-header") {{ $t('OrderLine.unitType') }}:
                span(class="summary-text") {{ ol.unitType }}
              v-col.justify-center.py-0.pr-0(cols="3")
                span(class="summary-header") {{$t('Product.name')}}:
                span(class="summary-text") {{ ol.product != null ? ol.product.name : "" }}
              v-col.justify-center.py-0.pr-0(cols="3")
                span(class="summary-header") {{$t('Product.description')}}:
                span(class="summary-text") {{ ol.product != null ? ol.product.description : "" }}
            v-row
              v-col.justify-center.py-0.pr-0(cols="3")
                span(class="summary-header") {{$t('Common.requestedDate', {type: 'Pickup'})}}:
                span(class="summary-text") {{ $formattedDate(ol.datePickupFrom, true) }}
              v-col.justify-center.py-0.pr-0(cols="3")
                span(class="summary-header") {{$t('Common.requestedDate', {type: 'Delivery'})}}:
                span(class="summary-text") {{ $formattedDate(ol.dateDeliveryFrom, true) }}
            v-row
              v-col.summary-col(cols="9")
                v-row
                  v-col.summary-col(v-for="oled in ol.orderLineExtraFields", cols="4")
                    span(class="summary-header") {{ oled.labelName }}:
                    span(class="summary-text")  {{ oled.value }}
            br
            br
      v-row.summary-row(v-for="sed in summaryInstance.orderExtraData")
        v-col(cols="2")
          h3.primaryHover--text {{ sed[0].groupName != null ? sed[0].groupName : sed[0].key != null ? sed[0].key.split('.')[0] : "" }}
        v-col(cols="10")
          v-row
            v-col.summary-col(v-for="ef in sed", cols="3")
              span(class="summary-header") {{ ef.extraField != null ? ef.extraField.label : ef.labelName }}:
              span(class="summary-text")    {{ ef.value }}
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text {{$tc('File._name', 2)}}
        v-col(cols="10")
          v-row(v-for="f in summaryInstance.files")
            v-col.summary-col.justify-center
              span(class="summary-header") {{ f.label }} :
              span(class="summary-text")  {{ f.fileName }}
              span(class="summary-text")  ({{ f.fileFormat }})
</template>

<style lang="scss" scoped>
  .summary-header{
    font-family: "Avenir LT", "Roboto", sans-serif;
    font-size: 14px;
    font-weight: bold;
    line-height: 17px;
  }
  .summary-text{
    font-family: "Avenir LT", "Roboto", sans-serif;
    font-size: 14px;
    line-height: 17px;
  }
  .summary-row{
    border-bottom: 1px solid #cccccc
  }
  .summary-col{
    padding: 2px 2px 2px 12px;
  }
</style>

<script>
import axios from 'axios';
import moment from 'moment-timezone';

export default {
  name: 'SummaryOrder',
  props: {
    parentInstance: {
      type: Object,
      default: () => { return {} }
    },
    entity: {
      type: Object
    },
  },
  filters: {
    fixed(val) {
      return Number.parseFloat(val).toFixed(2);
    },
  },
  data: function () {
    return {
      summaryInstance : {}
    }
  },
  watch: {
    parentInstance: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val != null) {
          this.updateSummaryInstance(val)
        }
      },
    },
  },
  methods: {
    /// parentInstance - Model instance listening all changes by the user when edit
    /// firstTimeInstance - Instance when load the first time from Summary Controller
    /// firstTime - Flag to know if its the first time load summary
    updateSummaryInstance(parentInstance, firstTimeInstance = null, firstTime = false){
      if(parentInstance.shipperReference != null ) this.summaryInstance.shipperReference = parentInstance.shipperReference
      if(parentInstance.receiverReference != null ) this.summaryInstance.receiverReference = parentInstance.receiverReference
      if(this.summaryInstance.createdBy == null) this.summaryInstance.createdBy = parentInstance.user ? parentInstance.user.fullName : ""
      if(this.summaryInstance.businessScope == null) this.summaryInstance.businessScope = parentInstance.businessScope.path

      // Party From
      if(parentInstance.datePickupFrom != null) this.summaryInstance.requestedPickUpFromDate = this.$cleanNulls(parentInstance.datePickupFrom)
      if(parentInstance.datePickupTo != null ) this.summaryInstance.requestedPickUpToDate = this.$cleanNulls(parentInstance.datePickupTo)
      if(parentInstance.partyFrom != null ){
        this.summaryInstance.partyFromName = this.$cleanNulls(parentInstance.partyFrom.name) + " (" + this.$cleanNulls(parentInstance.partyFrom.externalId) + ")"
        this.summaryInstance.partyFromStreetName = this.$cleanNulls(parentInstance.partyFrom.streetName) + " " + this.$cleanNulls(parentInstance.partyFrom.exteriorNumber)
        this.summaryInstance.partyFromInteriorNumber = this.$cleanNulls(parentInstance.partyFrom.interiorNumber)
        this.summaryInstance.partyFromCityName = this.$cleanNulls(parentInstance.partyFrom.cityName) + ", " + this.$cleanNulls(parentInstance.partyFrom.stateName) + ", "  + this.$cleanNulls(parentInstance.partyFrom.countryCode)
        this.summaryInstance.partyFromPostalCode = this.$cleanNulls(parentInstance.partyFrom.postalCode)
        this.summaryInstance.partyFromRemarks = this.$cleanNulls(parentInstance.partyFrom.remarks1)
        this.summaryInstance.partyFromContacts = parentInstance.orderContacts.filter(c => c.contactType == 0 && c.entityState != 2).map(c => ({
          contact: c.contact != null ? (this.$cleanNulls(c.contact.name) + " - " + this.$cleanNulls(c.contact.eMail) + " - " + this.$cleanNulls(c.contact.phoneNumber)) : null
        }));
        if(parentInstance.partyFrom.extraData != null) this.summaryInstance.partyFromExtraData = this.$cleanNulls(parentInstance.partyFrom.extraData)
      }

      //Party To
      if(parentInstance.dateDeliveryFrom != null) this.summaryInstance.requestedDeliveryFromDate = this.$cleanNulls(parentInstance.dateDeliveryFrom)
      if(parentInstance.dateDeliveryTo != null ) this.summaryInstance.requestedDeliveryToDate = this.$cleanNulls(parentInstance.dateDeliveryTo)
      if(parentInstance.partyTo != null ){
        this.summaryInstance.partyToName = this.$cleanNulls(parentInstance.partyTo.name) + " (" + this.$cleanNulls(parentInstance.partyTo.externalId) + ")"
        this.summaryInstance.partyToStreetName = this.$cleanNulls(parentInstance.partyTo.streetName) + " " + this.$cleanNulls(parentInstance.partyTo.exteriorNumber)
        this.summaryInstance.partyToInteriorNumber = this.$cleanNulls(parentInstance.partyTo.interiorNumber)
        this.summaryInstance.partyToCityName = this.$cleanNulls(parentInstance.partyTo.cityName) + ", " + this.$cleanNulls(parentInstance.partyTo.stateName) + ", "  + this.$cleanNulls(parentInstance.partyTo.countryCode)
        this.summaryInstance.partyToPostalCode = this.$cleanNulls(parentInstance.partyTo.postalCode)
        this.summaryInstance.partyToRemarks = this.$cleanNulls(parentInstance.partyTo.remarks1)
        this.summaryInstance.partyToContacts = parentInstance.orderContacts.filter(c => c.contactType == 1 && c.entityState != 2).map(c => ({
          contact: c.contact != null ? (this.$cleanNulls(c.contact.name) + " - " + this.$cleanNulls(c.contact.eMail) + " - " + this.$cleanNulls(c.contact.phoneNumber)) : null
        }));
        if(parentInstance.partyTo.extraData != null) this.summaryInstance.partyToExtraData = this.$cleanNulls(parentInstance.partyTo.extraData)
      }

      //OrderLines
      if(firstTime && parentInstance.entityState != 3) this.summaryInstance.orderLines = firstTimeInstance.orderLines
      else if(parentInstance.orderLines != null){
        this.summaryInstance.orderLines = parentInstance.orderLines.filter(ol => ol.entityState != 2).map(ol => ({
          lineNumber: ol.lineNumber,
          urgencyLevel: ol.urgencyLevel,
          status: ol.status,
          requestedQuantity: ol.requestedQuantity,
          availableQuantity: ol.availableQuantity,
          unitType: ol.unitType,
          product: ol.product,
          datePickupFrom: ol.datePickupFrom,
          dateDeliveryFrom: ol.dateDeliveryFrom,
          orderLineExtraFields: ol.extraData != null ? ol.extraData.map(ed => ({
            groupName: ed.key != null ? ed.key.split('.')[0] : '',
            labelName: ed.extraField != null ? ed.extraField.label : ed.labelName,
            value: ed.value
          })) : null
        }));
      } 

      //ExtraData
      if(firstTime) this.summaryInstance.orderExtraData = firstTimeInstance.orderExtraData
      else if(parentInstance.extraData != null){
        this.summaryInstance.orderExtraData = _.groupBy(parentInstance.extraData, function (ed) {
          return ed.key != null ? ed.key.split('.')[0] : ed.groupName;
        });
      }

      //Files already saved
      var currentFiles = []
      if(this.summaryInstance.files != null && parentInstance.files != null){
        parentInstance.files.forEach(
          element => currentFiles.push(this.summaryInstance.files.filter(f => f.id == element.id)[0])
        );
      }

      //Files to upload
      if(parentInstance.documentsRequestsToUpload != null){
        parentInstance.documentsRequestsToUpload.forEach(
          element => {
            let splitedFileName = element.FileName.split('.');
            const [ fileFormat ] = splitedFileName.slice(-1);
            splitedFileName.pop();
            currentFiles.push({
                label: element.DocumentRequestLabel,
                fileName: splitedFileName.join('.'),
                fileFormat
            })
          }
        );
      }
      this.summaryInstance.files = currentFiles
    },
    async load () {
      if (this.parentInstance.uid) {
        try {
          this.summaryInstance = (await axios.get(`summary/order/${this.parentInstance.uid}`)).data;
          this.updateSummaryInstance(this.parentInstance, this.summaryInstance, true)
        } catch (error) {
          console.error(error)
        }
      }
    },
  },
  async created() {
    await this.load();
  },
}
</script>

